module.exports = __webpack_public_path__ + "img/part-6-title.4f985e91.png";